<div class="section-header">
  <h2 class="section-title">Case Details</h2>
</div>
<p class="case-details-description">Foundational data and specifications for this record</p>
<div class="info-grid">
  <div class="info-item">
    <span class="info-label">Case ID</span>
    <span class="info-value" aut-id="case-id-value">{{ caseData().caseNumber }}</span>
  </div>
  <div class="info-item">
    <span class="info-label">Submitted By</span>
    <span class="info-value" aut-id="case-created-by-value">{{ caseData().createdBy }}</span>
  </div>
  <div class="info-item">
    <span class="info-label">Due Date</span>
    <span class="info-value" aut-id="case-due-date-value" [class.info-value--not-provided]="!caseData().dueDate">
      {{ caseData().dueDate ? (caseData().dueDate | date:'MMM d, yyyy') : 'Not provided' }}
    </span>
  </div>
  <div class="info-item">
    <span class="info-label">Submitted date</span>
    <span class="info-value" aut-id="case-created-date-value">{{ caseData().createdDate | date:'MMM d, yyyy' }}</span>
  </div>
  <div class="info-item">
    <span class="info-label">Case Type</span>
    <span class="info-value" aut-id="case-type-value">{{ caseData().caseType }}</span>
  </div>
  <div class="info-item">
    <span class="info-label">Category</span>
    <span class="info-value" aut-id="case-category-value">{{ caseData().category }}</span>
  </div>
</div>
